import { render, staticRenderFns } from "./EditOnOrdenes.vue?vue&type=template&id=5a5a4e07&"
import script from "./EditOnOrdenes.vue?vue&type=script&lang=js&"
export * from "./EditOnOrdenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports